import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobStatusDetail } from '../models/progress.model';
@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private readonly $event: BehaviorSubject<JobStatusDetail[]> = new BehaviorSubject<JobStatusDetail[]>([]);
  private readonly $status: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private exports: JobStatusDetail[] = [];

  public feedProcess(exports: JobStatusDetail[]): void {
    this.exports = exports;
    this.exports = this.exports.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id));
    this.$event.next(this.exports);
  }

  public onProcessReceived(): Observable<JobStatusDetail[]> {
    return this.$event.asObservable();
  }

  public updateProcess(index: number, exportItem: JobStatusDetail): void {
    this.exports[index] = exportItem;
  }

  public sendProcessStatus(message: string): void {
    this.$status.next(message);
  }

  public onProcessStatusRecieved(): Observable<string> {
    return this.$status.asObservable();
  }
}
